/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_welcome = /** @type {(inputs: {}) => string} */ () => {
	return `Vítejte v Acinonyxu`
};

const da_welcome = /** @type {(inputs: {}) => string} */ () => {
	return `Velkommen til Acinonyx`
};

const de_welcome = /** @type {(inputs: {}) => string} */ () => {
	return `Willkommen bei Acinonyx`
};

const en_welcome = /** @type {(inputs: {}) => string} */ () => {
	return `Welcome to Acinonyx`
};

const es_welcome = /** @type {(inputs: {}) => string} */ () => {
	return `Bienvenido a Acinonyx`
};

const fr_welcome = /** @type {(inputs: {}) => string} */ () => {
	return `Bienvenue dans Acinonyx`
};

const hu_welcome = /** @type {(inputs: {}) => string} */ () => {
	return `Üdvözöljük az Acinonyxban`
};

const it_welcome = /** @type {(inputs: {}) => string} */ () => {
	return `Benvenuto su Acinonyx`
};

const nl_welcome = /** @type {(inputs: {}) => string} */ () => {
	return `Welkom bij Acinonyx`
};

const pl_welcome = /** @type {(inputs: {}) => string} */ () => {
	return `Witamy w Acinonyx`
};

const pt_welcome = /** @type {(inputs: {}) => string} */ () => {
	return `Bem-vindo ao Acinonyx`
};

const sv_welcome = /** @type {(inputs: {}) => string} */ () => {
	return `Välkommen till Acinonyx`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const welcome = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.welcome(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("welcome", locale)
	if (locale === "cs") return cs_welcome(inputs)
	if (locale === "da") return da_welcome(inputs)
	if (locale === "de") return de_welcome(inputs)
	if (locale === "en") return en_welcome(inputs)
	if (locale === "es") return es_welcome(inputs)
	if (locale === "fr") return fr_welcome(inputs)
	if (locale === "hu") return hu_welcome(inputs)
	if (locale === "it") return it_welcome(inputs)
	if (locale === "nl") return nl_welcome(inputs)
	if (locale === "pl") return pl_welcome(inputs)
	if (locale === "pt") return pt_welcome(inputs)
	return sv_welcome(inputs)
};